import { isAfter, isValid, parseISO, startOfDay } from "date-fns";

import { type IEducationalScenarioSlotResource } from "@sol/sdk";

import { type ClassroomTemplateFormValues } from "./classroomTemplateSchema";

/** Training action bounds are derived from the imported periods: no date means nothing has started yet. */
export const hasTrainingActionStarted = (trainingActionStartDate: string | null | undefined, today: Date): boolean => {
    const startDate = trainingActionStartDate ? parseISO(trainingActionStartDate) : undefined;

    return !!startDate && isValid(startDate) && !isAfter(startOfDay(startDate), startOfDay(today));
};

/** Planned professional situations are served as simple slots; aggregated ones are server-side groupings. */
export const hasPlannedScenarioContent = (slots: Pick<IEducationalScenarioSlotResource, "type">[]): boolean =>
    slots.some(({ type }) => "simple" === type);

export const requiresPeriodsReimportConfirmation = (
    trainingActions: ClassroomTemplateFormValues["trainingActions"] = [],
    hasPlannedContent: boolean,
): boolean => hasPlannedContent && trainingActions.some(({ erpFile }) => erpFile instanceof File);
